export default __webpack_public_path__ + "f15af651c37d80e5964c638e0be0a9e7.png";